import FetchApi from "../util/fetchApi";
const fetchApi = new FetchApi();

export default class AzureService {
  async getData(data) {
    return (await fetchApi.post(`/azure`, data)).data;
  }

  async delete(data) {
    return (await fetchApi.post(`/azure/delete`, data)).data;
  }

  async download(Workspace_id, data, files) {
    return (await fetchApi.post(`/azure/${Workspace_id}/download?` + new URLSearchParams(data).toString(), files)).data;
  }

  async upload(formData, ProcessQueue_id, customHeaders) {
    return (await fetchApi.postFormData(`/azure/upload?ProcessQueue_id=${ProcessQueue_id}`, formData, customHeaders))
      .data;
  }

  async createFolder(data) {
    return (await fetchApi.post(`/azure/createfolder`, data)).data;
  }
}
